import React from "react";
import PropTypes from "prop-types";

export const VideoPreview = (props) => {
  const { selectedDocument } = props;
  const videoUrl = selectedDocument[0]?.uri.replace(
    "data:application/pdf",
    "data:video/mp4"
  );
  const fileName = selectedDocument[0]?.fileName;
  return (
    <div>
      <div className="viewer-header">
        <div
          id="file-name"
          data-testid="file-name"
          className="viewer-file-name"
        >
          {fileName}
        </div>
      </div>
      {selectedDocument && selectedDocument.length > 0 ? (
        <div className="pt-3">
          <video controls src={videoUrl} width="100%" height="auto">
            <track
              kind="captions"
              label="No captions"
              style={{ display: "none" }}
            />
            Your browser does not support the video element.
          </video>
        </div>
      ) : (
        <div>
          <br />
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      )}
    </div>
  );
};

VideoPreview.propTypes = {
  selectedDocument: PropTypes.arrayOf(
    PropTypes.shape({
      uri: PropTypes.string,
      fileName: PropTypes.string,
    })
  ),
};

VideoPreview.defaultProps = {
  selectedDocument: [],
};
